import type { FC, ReactNode } from 'react';
import * as Sentry from '@sentry/react';

interface SentryErrorBoundaryProps {
  children: ReactNode;
  fallback?: Sentry.ErrorBoundaryProps['fallback'];
}

export const SentryErrorBoundary: FC<SentryErrorBoundaryProps> = ({ children, fallback }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={
        fallback ||
        (({ error }) => (
          // TOOD: Display a nice error UI
          <div>
            <h1>Error</h1>
            <p>{(error as Error).message}</p>
          </div>
        ))
      }>
      {children}
    </Sentry.ErrorBoundary>
  );
};
